import { render, staticRenderFns } from "./InputAmount.vue?vue&type=template&id=0b6a242d&scoped=true&"
import script from "./InputAmount.vue?vue&type=script&lang=js&"
export * from "./InputAmount.vue?vue&type=script&lang=js&"
import style0 from "./InputAmount.vue?vue&type=style&index=0&id=0b6a242d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6a242d",
  null
  
)

export default component.exports